import { Component, OnDestroy, OnInit } from '@angular/core';
import { CustomerDAO } from '../../../core/services/dao/customerDAO';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';
import { CharterPaymentDAO } from '../../../core/services/dao/charterPaymentDAO';
import { take } from 'rxjs/operators';
import { EnvironmentalMediaService } from '../../../core/services/environmental-media.service';
import { StripePaymentDAO } from '../../../core/services/dao/stripePaymentDAO';
import { PaymentMethod, Stripe } from '@stripe/stripe-js';
import { CharterDAO } from '../../../core/services/dao/charterDAO';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { ExternalScriptService } from '../../../core/services/stripe.service';

@Component({
  selector: 'app-customer-payment-information',
  templateUrl: './customer-payment-information.component.html',
  styleUrls: ['./customer-payment-information.component.scss'],
})
export class CustomerPaymentInformationComponent
  implements OnInit, ContainsSubscriptions, OnDestroy
{
  hasPaymentMethods: boolean = false;
  loading: boolean = false;
  showAddNewContainer: boolean = false;
  subs: Subscription[] = [];
  paymentMethods: PaymentMethod[];
  stripe;
  elements = null;
  cardHolderName: string;
  stripeCustomer: any;
  charters: Charter[] = [];
  hasUncompletedCharters: boolean = false;
  stripeLoaded: boolean;

  constructor(
    private customerDAO: CustomerDAO,
    private charterPaymentDao: CharterPaymentDAO,
    private stripePaymentDao: StripePaymentDAO,
    private environmentalMediaService: EnvironmentalMediaService,
    private CharterDao: CharterDAO,
    private externalScriptService: ExternalScriptService,
  ) {
    externalScriptService.loadStripe().then(() => {
      console.log('loaded in Component');
      this.stripeLoaded = true;
      // @ts-ignore is global
      this.stripe = Stripe(
        this.environmentalMediaService.getStripePublishableKey(),
      );
      this.getPaymentMethods();
    });
  }

  ngOnInit() {
    this.getCharters();
    this.getStripeCustomer();
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }

  getCharters() {
    this.CharterDao.getCustomerCharters().subscribe((charters) => {
      charters.map((ch) => {
        if (
          (ch.paymentReceived &&
            !ch.completed &&
            !ch.cancelled &&
            ch.reconciliationStatus !== 'PAID') ||
          (ch.depositStatus === 'PAID' &&
            !ch.completed &&
            !ch.cancelled &&
            ch.reconciliationStatus !== 'PAID')
        ) {
          this.hasUncompletedCharters = true;
        }
      });
    });
  }

  addDropIn(): void {
    this.charterPaymentDao
      .createCharterPaymentIntent()
      .pipe(take(1))
      .subscribe((intent) => {
        const clientSecret = intent.client_secret;
        const appearance = {
          theme: 'stripe',
        };

        const paymentElementOptions = {
          layout: 'tabs',
          fields: {
            billingDetails: {
              name: 'never',
            },
          },
        };
        this.elements = this.stripe.elements({ appearance, clientSecret });
        const paymentElement = this.elements.create(
          'payment',
          paymentElementOptions,
        );
        paymentElement.mount('#payment-element');
        this.loading = false;

        const handleSubmit = async (e) => {
          e.preventDefault();
          this.loading = true;

          const { setupIntent, error } = await this.stripe.confirmSetup({
            elements: this.elements,
            redirect: 'if_required',
            confirmParams: {
              payment_method_data: {
                billing_details: {
                  name: this.cardHolderName,
                },
              },
              return_url: `${this.environmentalMediaService.getClientBaseURL()}customer/payment-information`,
            },
          });

          if (error) {
            const messageContainer = document.querySelector('#error-message');
            messageContainer.textContent = error.message;
          } else {
            this.stripePaymentDao
              .setDefaultPaymentMethod(setupIntent.payment_method)
              .subscribe((res) => {
                this.stripePaymentDao
                  .listCustomerPaymentMethods('04/10/2223')
                  .pipe(take(1))
                  .subscribe((paymentMethods) => {
                    this.paymentMethods = paymentMethods.data;
                    this.loading = false;

                    if (this.paymentMethods.length) {
                      this.hasPaymentMethods = true;
                      this.showAddNewContainer = false;
                    }
                  });
              });
          }
        };

        document
          .querySelector('#payment-form')
          .addEventListener('submit', handleSubmit);
      });
  }

  changePaymentClick(): void {
    this.showAddNewContainer = true;
    this.loading = true;
    this.addDropIn();
  }

  cancelPayment() {
    this.showAddNewContainer = false;
  }

  getPaymentMethods(): void {
    const sub = this.stripePaymentDao
      .listCustomerPaymentMethods('04/10/2223')
      .subscribe((paymentMethodData) => {
        this.paymentMethods = paymentMethodData.data;
        if (this.paymentMethods && this.paymentMethods.length) {
          this.hasPaymentMethods = true;
        } else {
          this.addDropIn();
        }
      });
    this.subs.push(sub);
  }

  getStripeCustomer(): void {
    const sub = this.stripePaymentDao
      .getStripeCustomerByUserId()
      .subscribe((stripeCustomer) => {
        this.stripeCustomer = stripeCustomer;
      });
    this.subs.push(sub);
  }
}
